import { useState } from 'react'

import classNames from 'classnames'

import { MissionCompleteStampIcon, MissionWinnerStampIcon } from '@local/assets/icons'

import { useRegistToSequentialList } from '@web/libs/sequential'

import styles from '../MissionCard.module.scss'

interface Props {
  order: number
}

export const CompletedAnimationStamp = ({ order }: Props) => {
  const [showAnimation, setShowAnimation] = useState<boolean>(false)

  useRegistToSequentialList({
    onExecute: () => setShowAnimation(true),
    durationSeconds: 0.5,
    delaySeconds: 0.8,
    order,
    id: `complete-${order}`,
    type: 'withPrev',
  })

  return (
    <span
      className={classNames(styles.complete_area, styles.icon_complete_wait_animation, {
        [styles.icon_complete_with_animation]: showAnimation,
      })}
    >
      <span className="place_blind">미션완료</span>
      <MissionCompleteStampIcon className={classNames(styles.icon_complete)} aria-hidden="true" />
    </span>
  )
}

const CompletedStamp = () => {
  return (
    <span className={classNames(styles.complete_area)}>
      <span className="place_blind">미션완료</span>
      <MissionCompleteStampIcon className={classNames(styles.icon_complete)} aria-hidden="true" />
    </span>
  )
}

export const WinnerStamp = () => {
  return (
    <span className={classNames(styles.complete_area)}>
      <span className="place_blind">당첨</span>
      <MissionWinnerStampIcon className={classNames(styles.icon_complete)} aria-hidden="true" />
    </span>
  )
}

export default CompletedStamp
